import React, { useRef, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import img1 from "../assets/img/bandeau.jpg";
import { Link } from 'react-router-dom';

export const Contact = () => {

  const form = useRef();

  const formInitialDetails = {
    name: '',
    prenom: '',
    mail: '',
    message: ''
  }
  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttonText, setButtonText] = useState('Envoyer');
  const [status, setStatus] = useState({ success: null, message: '' });


  async function sendEmail(e) {
    e.preventDefault();
    setButtonText("...");
    let response = await fetch("https://mails.maissadev.com/lumiere_a_donner.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify(formDetails),
    });
    setButtonText("Envoyer");
    let result = await response.json();
    setFormDetails(formInitialDetails);
    if (result.message == "OK") {
      setStatus({ success: true, message: 'Votre mail a bien été envoyé.' });
    } else {
      setStatus({ success: false, message: 'Une erreur s\'est produite, réessayez ou contactez-moi directement ici : jane.kuehn92@gmail.com' });
    }
  }

  const onFormUpdate = (field, value) => {
    setFormDetails((prevDetails) => ({ ...prevDetails, [field]: value }));
  };


  return (
    <div className=' min-height'>
      <div className='contact-container'>

        <Link to="/faq">
          <div className='single-container up-space-contact faq-contact-container contact-container-faq'>
            Retrouvez également certaines réponses dans notre FAQ.
          </div>
        </Link>


        <div className='single-container'>
          <p className='contact-text'>Pour toute demande d'information, veuillez m'écrire via le formulaire :</p>

          <Row>

            <Col xs={12}>
              <div className='form-container'>
                <form ref={form} onSubmit={sendEmail}>

                  <div className='form-nom-prenom'>
                    <div className="mb-3 margin-form-nom">
                      <input
                        type="text"
                        name="name"
                        value={formDetails.name}
                        onChange={(e) => onFormUpdate('name', e.target.value)}
                        className="form-control input-form"
                        placeholder="Nom"
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <input
                        type="text"
                        name="prenom"
                        value={formDetails.prenom}
                        onChange={(e) => onFormUpdate('prenom', e.target.value)}
                        className="form-control input-form"
                        placeholder="Prénom"
                        required
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <input
                      type="email"
                      name="mail"
                      value={formDetails.mail}
                      onChange={(e) => onFormUpdate('mail', e.target.value)}
                      className="form-control input-form"
                      placeholder="Email"
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <textarea
                      name="message"
                      value={formDetails.message}
                      onChange={(e) => onFormUpdate('message', e.target.value)}
                      className="form-control text-form"
                      rows="4"
                      placeholder="Message"
                      required
                    />
                  </div>

                  <div className="d-flex justify-content-end">
                    <button type="submit" className="bouton-rectangle-rim">
                      {buttonText}
                    </button>
                  </div>

                  {/* envoyer a jane.kuehn92@gmail.com */}

                </form>

                {status.success !== null && (
                  <div className={`status-message ${status.success ? 'success' : 'error'}`}>
                    {status.message}
                  </div>
                )}
              </div>
            </Col>

          </Row>
          <p className='contact-siren'> Siren : 528 389 430 - APE 8690F Activités de Santé Humaine nca </p>

        </div>
      </div>

    </div>

  );
}

